import { createSlice, createAsyncThunk, PayloadAction } from "@reduxjs/toolkit";
import { InspectionsState } from "../types/inspections/InspectionsState";
import { RootState } from "../redux/store";
import { getInspectionsByOrgId, GetInspectionsRequestData } from "../services/InspectionsServices";

const initialState: InspectionsState = {
   Inspections: [],
   InspectionsStatus: "idle",
   selectedInspection: null,
   activeTab: 0,
};

export const inspectionsSlice = createSlice({
    name: "inspectionsSlice",
    initialState,
    reducers: {
        setSelectedInspection: (state, action: PayloadAction<string>) => {
            state.selectedInspection = action.payload;
        },
        setActiveTab: (state, action: PayloadAction<number>) => {
            state.activeTab = action.payload;
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(getInspectionsThunk.fulfilled, (state, action) => {
               state.Inspections = action.payload;
               state.InspectionsStatus = "succeeded";
            })
            .addCase(getInspectionsThunk.pending, (state, _action) => {
                state.InspectionsStatus = "pending";
            })
            .addCase(getInspectionsThunk.rejected, (state, _action) => {
                state.InspectionsStatus = "failed";
            });
    }
});

export const getInspectionsThunk = createAsyncThunk(
    "inspections/getInspections",
    async (requestData: GetInspectionsRequestData) => {
        return getInspectionsByOrgId(requestData);
    }
);

export const inspectionsSelector = (state: RootState) => state.Inspections;
export const inspectionsActiveTabSelector = (state: RootState) => state.Inspections.activeTab;

export const { setSelectedInspection, setActiveTab } = inspectionsSlice.actions;

export default inspectionsSlice.reducer;
